import moment from 'moment';

export default function genererCritereRecherche() {
  return {
    annee: moment().year(),
    codes: [],
    codesDossier: [],
    commercialId: [],
    tiersId: [],
    etat: [],
    typesDeclaration: [],
    tiersDepartement: [],
  };
}
